// global.gsap = require("gsap");
// import gsap from "gsap";
// import testWebp from "./modules/sub/testwebp";

"use scrict";

// viiksi <3 legacy
  global.$ = require("jquery");

// messy globals + device detects
  const MobileDetect = require('mobile-detect');
  global.md = new MobileDetect(window.navigator.userAgent);
  global.MOBILE = md.mobile();
  global.TOUCH = (('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0));
  global.TABLET = navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2 &&
      /MacIntel/.test(navigator.platform);
  global.isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

// generic modules
  import { SVG } from '@svgdotjs/svg.js'
  // import svgPallo from './modules/svgPallo';
  // import svgSivu from './modules/svgSivu';
  import svgFrame from './modules/svgFrame';
  import winsizes from './modules/winSizes';
  require('optical-kerning');

// other
  window.winsizes = new winsizes();
  window.svgFrame = svgFrame;

// on document ready
$(function(){
  console.log('winready');
  
  $('.blob p').kerning({
    factor: .6,
    // exclude: [[0x00, 0xFF]]
  });
  

  // window.svgPallo = new svgPallo();
  // // window.svgSivu = new svgSivu();
  // window.svgPallo.resize();

  window.rotateAll = true;

  window.svgFrames = [];
  $('.section').each(function(){
    this.ball = new svgFrame(this);
  });

  // var wrapEl = $('.wrap').get(0);

  $('.schedule li').each(function(){
    var time = $(this).text().split(' ')[0];
    var rest = $(this).html().substring(time.length+3, $(this).html().length);
    var html = '<span class="time">'+time+'</span>' + rest;
    $(this).html(html);
  });
  

  window.prevFontSize = parseInt($('body').css('font-size'));
  window.prevWidth = window.innerWidth;

  setTimeout(function(){
    $('html').scrollTop(0);
    $('.hero').addClass('in');
    setTimeout(function(){
      $('html').addClass('in');

      if(MOBILE) {
        $(window).on('scroll', function(){
          for(var s=0;s<svgFrames.length; s++) {
            for(var i=0;i<svgFrames[s].textpaths.length; i++) {
              let path = svgFrames[s].textpaths[i];
              let rect = path.element().node.getBoundingClientRect();
              if(rect.top < window.innerHeight && rect.bottom > 0){
                if(path.timeline()._paused) {
                  path.timeline().play();
                }
              } else {
                if(!path.timeline()._paused) {
                  path.timeline().pause();
                }
              }
            }
          }
        });
      }

      setTimeout(function(){
        window.forceMobileResize = true;
        $(window).trigger('resize');
        $(window).scroll();
        window.forceMobileResize = false;
      }, 600);
    }, MOBILE ? 1800 : 1000);
  }, MOBILE ? 300 : 0);
});

$(window).on('load', function(){
  // window.forceMobileResize = true;
  // $(window).trigger('resize');
  // window.forceMobileResize = false;
});

$(window).on('resize', function(){

  if(window.prevFontSize !== parseInt($('body').css('font-size'))){
    window.forceMobileResize = true;
  }


  if(window.innerWidth==window.prevWidth && MOBILE && !window.forceMobileResize) {
  } else {
    window.winsizes.resize();
    // window.svgPallo.resize();
    // window.svgSivu.resize();
    clearTimeout(window.clearFramesTime);
    window.clearFramesTime = setTimeout(function(){
      for(var i=0;i<svgFrames.length; i++) {
        svgFrames[i].demolish();
      }
      window.svgFrames = [];
      $('.section').each(function(){
        new svgFrame(this);
      });
      $(window).scroll();
    }, 100);
    window.prevWidth = window.innerWidth;
  }

  window.forceMobileResize = false;
  window.prevFontSize = parseInt($('body').css('font-size'));

});
